<template>
  <div>
    <div class="card card-custom card-stretch gutter-b">
      <div class="card-header">
        <div class="card-title">
          <span class="card-icon">
            <i class="flaticon2-delivery-package text-primary"></i>
          </span>
          <h3 class="card-label"><b class="title-header">{{BusinessTitle}}</b></h3>
        </div>
      </div>
      <div class="card-body">
        <div>
          <div v-if="business_from && business_to">
            <p class="mb-0">事業期間：</p>
            <p>{{`${business_from} ~ ${business_to}`}}</p>
          </div>
          <p>表示期間</p>
        </div>
        <div class="mb-4">
          <div>
            <el-form ref="ruleForm" :model="form" class="form-base" v-on:submit.prevent="isSubmit=true">
              <div class="row ml-0">
                <el-form-item prop="dateStart">
                  <el-date-picker v-model="form.day_from.year" :picker-options="pickerOptions" :clearable="false" type="year" value-format="yyyy" prefix-icon="el-icon-arrow-down"
                     :editable="false"></el-date-picker>
                  <span> 年 </span>
                  <el-date-picker v-model="form.day_from.month" :picker-options="pickerOptions" :clearable="false" type="month" format="MM" prefix-icon="el-icon-arrow-down"
                     :default-value="form.day_from.year ? fromYear : new Date()" :editable="false">
                  </el-date-picker>
                  <span> 月 </span>
                  <span style="font-size: 20px"> ～ </span>
                </el-form-item>

                <el-form-item prop="dateEnd">
                  <el-date-picker v-model="form.day_to.year" :picker-options="pickerOptions" :clearable="false" type="year" value-format="yyyy"  prefix-icon="el-icon-arrow-down"
                   :editable="false"></el-date-picker>
                  <span> 年 </span>
                  <el-date-picker v-model="form.day_to.month" :picker-options="pickerOptions" :clearable="false" type="month" format="MM" prefix-icon="el-icon-arrow-down"
                      :editable="false">
                  </el-date-picker>
                  <span> 月 </span>
                  <p v-if="errorTime" class="error">{{errorTime}}</p>
                </el-form-item>
              </div>
              <input type="hidden" name="_csrf" v-model="form._csrf" />
            </el-form>
          </div>
          <div class="row mb-8">
            <div class="col-md-3">予算額: {{sum_yosan_gaku ? formatter(sum_yosan_gaku) : '--'}}</div>
            <div class="col-md-3">実績額: {{sum_jisseki_gaku ? formatter(sum_jisseki_gaku) : '--'}}</div>
            <div class="col-md-6">予算消化率: {{percent}}</div>
            </div>
            <el-table border stripe max-height="470" header-cell-class-name="text-center"  v-loading="loading"
              :header-cell-style="{ background: '#181c32', color: 'white' }" :data="data">
              <el-table-column fixed prop="title" label="項目" width="320" :width="data.length > 0 ? '326' : ''"></el-table-column>
              <el-table-column v-for="(header,key) in listHeaders" :label="header">
                <el-table-column label="予算" min-width="150" :prop="`${header}_yosan_gaku`" :key="`${key}_${header}_yosan_gaku`">
                  <template slot-scope="scope">
                    <input style="text-align:left;" class="input-price" :key="`${key}_${header}_yosan_gaku`"
                       @blur="scope.row[`${header}_yosan_gaku`] =   convertbyte($event,scope.row[`${header}_yosan_gaku`])"
                      :disabled="scope.row.status == 1" onfocus="if(this.value) this.value = this.value.replace(/\D/g, '')" maxlength="20"
                      v-model.lazy="scope.row[`${header}_yosan_gaku`]">
                    </template>
                    </el-table-column>
                    <el-table-column label="実績" min-width="150" :prop="`${header}_jisseki_gaku`" :key="`${key}_${header}_jisseki_gaku`">
                      <template slot-scope="scope">
                        <input style="text-align:left;" class="input-price" :key="`${key}_${header}_jisseki_gaku`"
                          :disabled="scope.row.status == 1" onfocus="if(this.value) this.value = this.value.replace(/\D/g, '')"
                          @blur="scope.row[`${header}_jisseki_gaku`] =   convertbyte($event,scope.row[`${header}_jisseki_gaku`])"
                          maxlength="20" v-model.lazy="scope.row[`${header}_jisseki_gaku`]">
                      </template>
                   </el-table-column>
                </el-table-column>
            </el-table>
           </div>

          <div class="text-center">
                <button class="btn btn-primary" @click="openPopup()">確認</button>
            </div>
          </div>
          </div>
          <Popup :id="id" :title_button="'はい'" :title="''" :content="'入力値で予算・実績値を更新しますか？'">
            <b-button class="btn-primary" @click="submitForm()">はい</b-button>
            <b-button class="btn-primary" @click="closePopup()">いいえ</b-button>
          </Popup>
  </div>
</template>

<script>
import moment from 'moment'
import Popup from '@/view/components/Popup'
import { LIST_TRANSACTION } from "@/core/services/store/forecast.module";
import { mapActions, mapGetters } from 'vuex';
import store from '../../../core/services/store';
import apiService from "@/core/services/api.service";
import { SET_TITLE_BUSINESS } from "@/core/services/store/business.module";
import { SUCCESS_MESSAGE } from "@/core/config/constant";
import { getCsrfRandom } from "@/core/services/store/auth.module";

export default {
  components: {
    Popup,
  },
  data() {
    return {
      loading: false,
      budgetData: [],
      form: {
        day_from: {
          year: '',
          month: ''
        },
        day_to: {
          year: '',
          month: ''
        },
        _csrf:''
      },
      id: '1',
      listHeaders: [],
      formData: [],
      errorTime: null,
      dataForm: [],
      data: [],
      sum_yosan_gaku: 0,
      sum_jisseki_gaku: 0,
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      business_from: '',
      business_to: '',
      checkButton:false
    };
  },
  watch: {
    'form.day_from.year': {
      handler: function () {
        if (!this.isSubmit && this.form.day_from.year && this.form.day_from.month) {
          this.form.day_from.month = new Date(
            this.form.day_from.year ? moment(this.form.day_from.year).format('yyyy') : new Date().getFullYear(),
            this.form.day_from.month ? moment(this.form.day_from.month).format('MM') - 1 : new Date().getMonth()
          )
        }
      },
      deep: true
    },
    'form.day_from.month': {
      handler: function () {
        if (!this.isSubmit) {
          this.form.day_from.year = this.form.day_from.month ? moment(this.form.day_from.month).format('yyyy') : this.form.day_from.year
        }
      },
      deep: true
    },
    'form.day_to.year': {
      handler: function () {
        if (!this.isSubmit && this.form.day_to.year && this.form.day_to.month) {
          this.form.day_to.month = new Date(
            this.form.day_to.year ? moment(this.form.day_to.year).format('yyyy') : new Date().getFullYear(),
            this.form.day_to.month ? moment(this.form.day_to.month).format('MM') - 1 : new Date().getMonth()
          )
        }
      },
      deep: true
    },
    'form.day_to.month': {
      handler: function () {
        if (!this.isSubmit) {
          this.form.day_to.year = this.form.day_to.month ? moment(this.form.day_to.month).format('yyyy') : this.form.day_to.year
        }
      },
      deep: true
    },
    form: {
      handler: async function () {
        if (this.form.day_from.year && this.form.day_from.month && this.form.day_to.year && this.form.day_to.month) {
          this.$refs["ruleForm"].clearValidate()
          const time =
            { "dateEnd": `${moment(this.form.day_to.year).format('yyyy')}-${moment(this.form.day_to.month).format('MM')}`
            , "dateStart": `${moment(this.form.day_from.year).format('yyyy')}-${moment(this.form.day_from.month).format('MM')}`,
            isUpdate: 0,
            tax_flag: this.getBusiness.use_tax
          }
          this.loading = true
          await store.dispatch(LIST_TRANSACTION,time )
          if (this.ForecastStatus == 200) {
            this.budgetData = this.getListTransaction
            this.tableCostData()
          }

          if (this.ForecastStatus == 422) {
                if (data.data.data?.dataForm){
                    this.notifyError(data.data.data.dataForm[0])
                }
              this.showErrorMessage(this.ForecastErrors, "ruleForm")
            this.budgetData = this.getListTransaction
          }

          this.loading = false
        }
      },
      deep: true
    },

  },
  computed: {
    ...mapGetters(['BusinessTitle', "getListTransaction", 'ForecastErrors', 'ForecastStatus', 'getListTitle', 'getBusiness']),
    fromYear() {
      return this.form.day_from.year ? moment(this.form.day_from.year).format('yyyy') : new Date().getFullYear()
    },
    fromMonth() {
      return this.form.day_from.month ? moment(this.form.day_from.month).format('MM') - 1 : new Date().getMonth()
    },
    toYear() {
      return this.form.day_to.year ? moment(this.form.day_to.year).format('yyyy') : new Date().getFullYear()
    },
    toMonth() {
      return this.form.day_to.month ? moment(this.form.day_to.month).format('MM') - 1 : new Date().getMonth()
    },
    percent() {
      return this.sum_jisseki_gaku && this.sum_yosan_gaku ? Number((this.sum_jisseki_gaku / this.sum_yosan_gaku) * 100).toFixed(2) + '%' : '--'
    },
  },
  async created() {
    this.loading = true;
    let query = {};
    if (this.BusinessTitle == null) {
      await this.setTitleBusiness()
    }

    if (this.getBusiness) {
      this.business_from = moment(this.getBusiness.jigyo_kikan_from).format('YYYY/MM/DD')
      this.business_to = moment(this.getBusiness.jigyo_kikan_to).format('YYYY/MM/DD')
    }

    if (this.$route.query.dateStart) {
      query.dateStart = this.$route.query.dateStart
      const get_year = query.dateStart.indexOf('-');
      this.form.day_from.year = query.dateStart.slice(0, get_year)
      this.form.day_from.month = new Date(query.dateStart)
    }
    if (this.$route.query.dateEnd) {
      query.dateEnd = this.$route.query.dateEnd
      const get_year = query.dateEnd.indexOf('-');
      this.form.day_to.year = query.dateEnd.slice(0, get_year)
      this.form.day_to.month = new Date(query.dateEnd)
    }
    this.form._csrf = getCsrfRandom()
    this.loading = false;
  },
  methods: {
    ...mapActions([LIST_TRANSACTION, SET_TITLE_BUSINESS]),
    openPopup() {
      this.$bvModal.show(this.id)
    },

    async submitForm() {
      this.isSubmit = true
      this.loading = true
      this.dataForm = []
      this.data.forEach((row) => {
        let arrayTitle = [];
        for (const [key, value] of Object.entries(row)) {
          let hasDate = false
          const get_date = key.indexOf('_');
          let date;
          let key_name;

          if (get_date != -1) {
            date = key.slice(0, get_date)
            key_name = key.replace(`${date}_`, '')
          }

          if (date && !arrayTitle.includes(date)) {
            hasDate = true
            arrayTitle.push(date)
          }

          if (hasDate) {
            this.dataForm.push({ himoku_id: row.id, taisho_ym: date })
          }

          if (arrayTitle.includes(date)) {
            this.dataForm.map(data => {
              if (data['taisho_ym'] == date && data['himoku_id'] == row.id) {
                if ((key_name == "jisseki_gaku" || key_name == "yosan_gaku")){
                  if (value) data[key_name] = value.replaceAll(',', '')
                  else  data[key_name] = null
                }
              }
            })
          }
        }
      });

      this.dataForm.map(data => {
        data['taisho_ym'] = moment(data['taisho_ym'],'YYYY/MM').format('YYYY-MM')
      })
      apiService.post(`forecast/add-transaction`, { dataForm: this.dataForm }).then(async (data) => {
        if (data && data.data && data.data.success) {
          const time =
          {
            "dateEnd": `${moment(this.form.day_to.year).format('yyyy')}-${moment(this.form.day_to.month).format('MM')}`
            , "dateStart": `${moment(this.form.day_from.year).format('yyyy')}-${moment(this.form.day_from.month).format('MM')}`,
            isUpdate: 0,
            tax_flag: this.getBusiness.use_tax
          }
          await this.listTransaction(time)
          this.notifySuccess(SUCCESS_MESSAGE)
          this.budgetData = this.getListTransaction
          this.tableCostData()
        } else {
          if (data.data.code == 422) {
              if (data.data.data?.dataForm){
                  this.notifyError(data.data.data.dataForm[0])
              }
            this.showErrorMessage(data.data.data, 'ruleForm')
          } else if (data.data.code == 400) {
            this.notifyError(data.data.message)
          } else {
            this.notifyError('error server')
          }
        }
        this.loading = false
      })
        .catch(e => {
          this.loading = false
          this.notifyError(e)
        })
      this.isSubmit = false
      this.$bvModal.hide(this.id)
    },
    closePopup() {
      this.$bvModal.hide(this.id);
    },
    tableCostData() {
      let hasTitleArray = []
      this.data = []
      this.listHeaders = []
      this.sum_yosan_gaku = 0
      this.sum_jisseki_gaku = 0

      //get title for table row
      const listJimukanri = this.getListTitle
      if (listJimukanri) {
        listJimukanri.forEach(title => {
          this.data.push({
            id: title.himoku_id,
            title: title.himoku_name,
            status: title.saiitaku_flg_befor_update
          })
        })
      }

      for (const [registered_date, value] of Object.entries(this.budgetData.data)) {
        if (!this.listHeaders.includes(registered_date)) {
          this.listHeaders.push(registered_date)
        }
          this.sum_yosan_gaku = this.formatNumber(this.budgetData.totalForm2 ? this.budgetData.totalForm2 : 0)
          this.sum_jisseki_gaku = this.formatNumber(this.budgetData.totalForm3 ? this.budgetData.totalForm3 : 0)
          if (value.length) {
          value.forEach(value_item => {
            //get data for table row
            if (this.data.length) {
              this.data.map(array_item => {
                if (array_item.id == value_item.himoku_id) {
                  array_item[`${registered_date}_yosan_gaku`] = value_item.yosan_gaku != null ? BigInt(String(value_item.yosan_gaku).replace(/\D/g, ''), 10).toLocaleString('ja-JP', { currency: 'JPY' }) : ''
                  array_item[`${registered_date}_taisho_ym`] = registered_date
                  array_item[`${registered_date}_himoku_id`] = value_item.himoku_id
                  array_item[`${registered_date}_jisseki_gaku`] = value_item.jisseki_gaku != null ? BigInt(String(value_item.jisseki_gaku).replace(/\D/g, ''), 10).toLocaleString('ja-JP', { currency: 'JPY' }) : ''
                }
              })
            }
          })
        }
      }
      if (this.data.length) {
        const month_range = moment(this.form.day_to.month).diff(this.form.day_from.month, 'months')
        const start_month = moment(this.form.day_from.month).format('YYYY/MM')
        for (let i = 0; i <= month_range; i++) {
          if (i == 0) {
            if (!this.listHeaders.includes(start_month)) {
              this.listHeaders.push(start_month)
            }
          } else {
            const month = moment(start_month, 'YYYY/MM').add(i, 'M').format('YYYY/MM')
            if (!this.listHeaders.includes(month)) {
              this.listHeaders.push(month)
            }
          }
        }

        this.listHeaders.sort((a, b) => {
          if (moment(a).isBefore(b, 'month')) {
            return -1
          }

          if (moment(a).isAfter(b, 'month')) {
            return 1
          }

          if (moment(a).isSame(b, 'month')) {
            return 0
          }
        })
        if (this.sum_yosan_gaku || this.sum_jisseki_gaku) {
          this.checkButton = true
        }

      }



    },
    disabledDate(date) {
      return moment(date).isBefore(this.getBusiness.jigyo_kikan_from) || moment(date).isAfter(this.getBusiness.jigyo_kikan_to)
    },
    formatter(unformated_cost) {
        if (unformated_cost == '--'){
            return unformated_cost
        }
      const cost = BigInt(unformated_cost)
      const formatter = new Intl.NumberFormat('ja-JP', { currency: "JPY" }).format(cost)
      return formatter
    },
    convertbyte(e, money) {
      if (money && money!=0) {
        for (let i = 0; i < money.length; i++) {
          if (money[i] < '0' || money[i] > '9' && money[i] < '０' || money[i] > '９') {
            money = money.substring(0, i) + money.substring(i + 1);
            i--;
          }
        }
        money = this.fullWidthNumConvert(money);
        if (money) {
          this.checkButton = true
          e.target.value = BigInt(money.replace(/\D/g, ''), 10).toLocaleString('ja-JP', { currency: 'JPY' });
          return BigInt(money.replace(/\D/g, ''), 10).toLocaleString('ja-JP', { currency: 'JPY' });
        }else  e.target.value = null
      }else{
        let check = false;
        this.data.forEach((key) => {

          for (const [index, value] of Object.entries(key)) {
                if(index.includes('_jisseki_gaku') || index.includes('_yosan_gaku')){
                  if(value != undefined && value != ''){
                    this.checkButton = true
                    check = true;
                  }else{
                    this.checkButton = false
                  }
                }

                if(check){
                  break;
                }
        }
        })
      }
    },
    fullWidthNumConvert(fullWidthNum) {
      var ascii = '';
      if (fullWidthNum) {
        for (var i = 0, l = fullWidthNum.length; i < l; i++) {
          var c = fullWidthNum[i].charCodeAt(0);
          if (c >= 0xFF00 && c <= 0xFFEF) {
            c = 0xFF & (c + 0x20);
          }

          ascii += String.fromCharCode(c);
        }
      }
      return ascii;

    },
    convertReplace(value) {
      if (value) {
        return value.replace(/\D/g, '')
      }
    },
  }
}
</script>

<style scoped>
.center-text {
  line-height: 43px;
}
.error {
  color:red;
}
.input-price{
  -webkit-appearance: none;
    background-color: #FFF;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: bo;
    width: 100%;
}
</style>
